import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import { Field } from 'react-final-form';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import { applyStyles } from 'util/helpers';
import InputContainer from './components/InputContainer';
import CustomMedia from 'util/custom-media-query';

const TextField = ({
  className,
  name,
  label,
  labelNote,
  validate,
  required,
  ...inputProps
}) => (
  <div className={className}>
    <Field
      name={name}
      type="hidden"
      validate={validate}
      parse={value => (value ? value : '')}
      render={({ input, meta }) => (
        <React.Fragment>
          <InputContainer input={input} meta={meta} inputProps={inputProps} />
        </React.Fragment>
      )}
    />
  </div>
);

TextField.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelNote: PropTypes.string,
  validate: PropTypes.func,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  notes: PropTypes.arrayOf(PropTypes.string)
};

const commonStyle = css`
  label {
    ${FontStyles.text5}

    display: flex;
    color: ${Colors.black1};
    align-items: center;

    span {
      display: block;
    }

    .label-notes {
      ${FontStyles.text7};

      text-indent: -1.25em;
      padding-left: 1.25em;
      margin: 0;
    }
  }

  .tag {
    ${FontStyles.text11};

    display: block;
    width: 38px;
    height: 22px;
    line-height: 22px !important;
    background-color: ${Colors.orange1};
    color: ${Colors.white1};
    text-align: center;
    font-style: normal;
    border-radius: 4px;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  margin: 0;
  label {
    margin: 0 0 12px 0;

    span {
      margin-right: 8px;
    }

    .label-notes {
      margin-left: 8px;
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin: 0;

  padding: 0 16px;
  width: 100%;

  label {
    margin: 0 0 12px 0;
    flex-wrap: wrap;

    span {
      margin-right: 4px;
    }

    .label-notes {
      margin-top: 6px;
    }
  }
`;

export default applyStyles(TextField)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/HiddenField/index.js